<template>
    <div class="ssv-form">
        <div class="input-item input-item--large-top-space">
            <label class="label">
                Poznámka (<span class="text--small" v-html="placeholder"/>)
            </label>
            <textarea class="textarea textarea--xxl" v-model="note"></textarea>
        </div>
    </div>
</template>

<script>
    import {mapFields} from 'vuex-map-fields';

    export default {
        name:     'SsvOrderNote',
        props:    {
            placeholder: {
                type:    String,
                default: 'potřebujete-li sdělit cokoli pořadateli',
            },
        },
        computed: {
            ...mapFields('ssvOrder', [
                'parameters.note',
            ]),
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/parameters/OrderNote.vue